import React from "react";
import { Card, CardBody } from "reactstrap";
import "./MediaSkeleton.css";

const MediaSkeleton = () => {
  return (
    <Card className="media-skeleton h-100 border-0" style={{ borderRadius: "10px" }}>
      <div className="skeleton-image" style={{ height: "180px" }} />
      <CardBody className="px-3 py-3 pb-0">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="skeleton-line" style={{ width: "70%", height: "18px" }} />
          <div style={{ display: "flex", gap: "8px" }}>
            <div className="skeleton-line" style={{ width: "36px", height: "36px", borderRadius: "50%" }} />
            <div className="skeleton-line" style={{ width: "36px", height: "36px", borderRadius: "50%" }} />
          </div>
        </div>
        <div className="skeleton-line mt-2" style={{ width: "80%", height: "12px" }} />
      </CardBody>
    </Card>
  );
};

export default MediaSkeleton;
